// extracted by mini-css-extract-plugin
export default {"container":"prompt-module__container___LAhnb","prompt":"prompt-module__prompt___fjzLU","text":"prompt-module__text___M3IIv","thumb":"prompt-module__thumb___YcajT"};